export default __webpack_public_path__ + "static/media/logo.3dd632f3.png";